import React from 'react';
import { Styled } from "./styles"

const CustomCheckBox = (props) => {
  return <Styled
    onClick={() => props.onChange(!props.checked)}
  >
    <input
      type="checkbox"
      checked={props.checked}
      onChange={() => {}}
    />
    <label>{props.label}</label>
  </Styled>
}


export default CustomCheckBox;